<template>
    <div id="scan_action_prototypes" class="x_scrollable">
        <ErrorMessages :errors="errors" :description="$t('ui.general.error')" :is_closable="true"></ErrorMessages>

        <div v-if="is_initialized"
            class="right floated ui button"
            @click="print_scan_action_prototypes()">
            <i class="print icon"></i>
            <!-- 列印貨況條碼 -->
            {{ $t('ui.pages.scan_action_prototypes.print_barcodes') }}
        </div>

        <Print
            class="printarea"
            v-if="is_initialized"
            :scan_action_prototypes="scan_action_prototypes"
            >
        </Print>

        <div class="clear"></div>

        <div class="ui segment">
            <div v-if="style.width < 767" style="margin-bottom: 1em;">
                <div v-if="is_loading">
                    <div class="ui active centered inline loader"></div>
                </div>
                <DataCard
                    v-else
                    v-for="scan_action_prototype in scan_action_prototypes"
                    :key="scan_action_prototype.identity"
                    :object="scan_action_prototype"
                    :title="scan_action_prototype.name"
                    :title_link="{name: 'scan_action_prototype', params: {identity: scan_action_prototype.identity}}"
                    :sub_title="scan_action_prototype.barcode"
                    :is_show_column="false"
                    :keys="['barcode']"
                    :i_18n_key="'scan_action_prototypes'"
                >
                    <div slot="barcode" style="text-align: center;">
                        <barcode
                            :value="scan_action_prototype.barcode"
                            :tag="'svg'"
                            :options="{
                                background: 'transparent',
                                displayValue: true,
                                format: 'CODE128',
                                width: 1,
                                height: 25
                            }">
                            看見此資訊請通知系統工程師。
                        </barcode>
                    </div>
                </DataCard>

                <div v-if="!is_loading && scan_action_prototypes.length <= 0"
                    class="ui center aligned red segment">
                    <h3>
                        {{ $t('ui.general.no_data') }}
                    </h3>
                </div>
            </div>
            <table v-else class="ui compact celled table">
                <thead class="center aligned">
                    <tr>
                        <th colspan="2">{{ $t('models.attributes.scan_action_prototypes.barcode') }}</th>
                        <th>{{ $t('models.attributes.scan_action_prototypes.name') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="is_loading" class="center aligned">
                    <tr class="loading">
                        <td colspan="6">
                            <div class="ui active centered inline loader"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else class="center aligned">
                    <ScanActionPrototype v-for="scan_action_prototype in scan_action_prototypes" :key="scan_action_prototype.identity" :scan_action_prototype="scan_action_prototype">
                    </ScanActionPrototype>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import ScanActionPrototype from "../.components/index/item.vue"
import Paginator from '@toolbox/pagination/paginator.vue'
import ErrorMessages from '@toolbox/error_box/main.vue'
import VueBarcode from '@chenfengyuan/vue-barcode'
import DataCard from '@toolbox/data_card/main.vue'
import Print from "./index/print.vue"

export default {
    name: "ScanActionPrototypesIndex",
    data() {
        return {
            is_initialized: false,
            is_loading: false,
            scan_action_prototypes: [],
            errors: [],
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
        current_page() {
            return this.$store.state.provider.scan_action_prototypes_module.pagination.current_page
        },
        total_pages() {
            return this.$store.state.provider.scan_action_prototypes_module.pagination.total_pages
        },
        search_params() {
            return this.$store.state.provider.scan_action_prototypes_module.search_params
        },
        show_filter() {
            return this.$store.state.provider.scan_action_prototypes_module.show_filter
        }
    },
    created() {
    },
    mounted() {
        this.init()
        this.$bus.$off('init')
        this.$bus.$on('init', (value = false) => {
            this.init()
        })
    },
    beforeDestroy() {
        this.$bus.$off('init')
    },
    watch: {
    },
    methods: {
        async init() {
            try {
                await new Promise(resolve => {
                    this.is_initialized = false
                    resolve()
                })
                await this.fetch_scan_action_prototypes()
                await new Promise(resolve => {
                    this.is_initialized = true
                    this.$noty.information(
                        this.$t("ui.page_titles.scan_action_prototypes") + ' ' +
                        this.$t('ui.general.initialize_complete')
                    , 300)
                    resolve()
                })
            } catch (e) {
                this.$noty.error(e)
            } finally {
                this.is_loading = false
                // pagination channel
                this.$bus.$off('index_page')
                this.$bus.$on('index_page', (page = null) => {
                    this.fetch_scan_action_prototypes(page)
                })
            }
        },
        fetch_scan_action_prototypes(page = 0) {
            this.is_loading = true
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_scan_action_prototypes).parse(
                {},
                "?" + object_to_query({
                    simple: true,
                })
            )
            return axios.get(url, { headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.scan_action_prototypes = _.orderBy(response.data.scan_action_prototypes, ['barcode', 'name'], ['asc', 'asc'])
                    } else {
                        console.log(response.data)
                    }
                })
                .catch(error => {
                    console.log(error.response)
                    // this.$noty.error('取得scan_action_prototypes失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.roles'),
                            reason: ': ' + error.response
                        })
                    )
                })
                .then(() => {
                    setTimeout(() => {
                        this.is_loading = false
                    }, 300)
                })
        },
        async print_scan_action_prototypes() {
            // 初始化列印空間
            await new Promise(resolve => {
                $("div#print").html("")
                resolve()
            })
            // 等待列印內容轉錄至列印空間
            await new Promise(resolve => {
                $(".printarea").clone().appendTo('div#print')
                resolve()
            })
            // 呼叫列印視窗
            await new Promise(resolve => {
                window.print()
                this.is_printing = false
                resolve()
            })
        },
    },
    components: {
        'barcode': VueBarcode,
        ScanActionPrototype,
        ErrorMessages,
        Paginator,
        DataCard,
        Print,
    }
}
</script>
